import React, { ReactNode, useMemo } from 'react'

import { IconName } from 'components_new/atoms/Icon'

import Box from 'components_new/atoms/Box'
import Collapse from 'components_new/atoms/Collapse'
import Skeleton from 'components_new/atoms/Skeleton'

import NavigationItem, {
  TNavigationItem
} from 'components_new/molecules/NavigationItem'
import NavigationTitle from 'components_new/molecules/NavigationTitle'
import { ChipProps } from 'components_new/atoms/Chip'

export interface NavigationMenuProps {
  actions?: ReactNode
  chip?: ChipProps
  collapsed: {
    activePattern: TNavigationItem['activePattern']
    iconName: IconName
    href: string
    value: boolean
  }
  disableHistory?: boolean
  expandedItems: string[]
  iconName?: IconName
  id: string
  items: TNavigationItem[]
  loading?: boolean
  onAdd?: () => void
  toggleNavigationItem: (id: string) => void
  title: string
}

const NavigationMenu = (props: NavigationMenuProps) => {
  const {
    actions,
    chip,
    collapsed,
    disableHistory,
    expandedItems,
    iconName,
    id,
    items,
    loading,
    onAdd,
    toggleNavigationItem,
    title
  } = props

  const expanded = expandedItems.includes(id)

  const memoizedBody = useMemo(
    () => (
      <Box sx={{ mb: expanded && !collapsed ? 2 : 0 }}>
        <NavigationTitle
          actions={actions}
          chip={chip}
          collapsed={collapsed}
          expanded={expanded}
          iconName={iconName}
          onAdd={onAdd}
          onToggle={() => toggleNavigationItem(id)}
          title={title}
        />
        <Collapse in={expanded && !collapsed.value}>
          <Box sx={{ mb: 2, mt: 1 }}>
            {items.map((item) => (
              <NavigationItem
                key={item.id || item.href}
                collapsed={collapsed.value}
                disableHistory={disableHistory}
                expandedItems={expandedItems}
                indent={iconName ? 1 : undefined}
                item={item}
                onToggle={toggleNavigationItem}
              />
            ))}
          </Box>
        </Collapse>
      </Box>
    ),
    [
      expanded,
      actions,
      expanded,
      iconName,
      title,
      collapsed,
      disableHistory,
      expandedItems
    ]
  )

  /*-- default --*/
  return (
    <>
      {loading && !collapsed.value ? (
        <>
          <Box sx={{ mb: 3 }}>
            <Skeleton
              variant="rounded"
              height={24}
              width={'50%'}
              sx={{ mb: 1 }}
            />
            {[1, 2, 3].map((i) => (
              <Skeleton
                height={24}
                key={i}
                sx={{ mb: 1 }}
                variant="rounded"
                width={'100%'}
              />
            ))}
          </Box>
        </>
      ) : (
        memoizedBody
      )}
    </>
  )
}

export default NavigationMenu
